<div>
  <!-- Section header: title, guidance, and the one primary action. -->
  <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
    <div class="flex-grow-1">
      <h3 class="fs-18 fw-500 m-0 text-dark">
        Amendment Document @if (sequenceNumber() > 1) { #{{ sequenceNumber() }} }
      </h3>
      <p class="fs-14 mb-0 mt-1 text-muted">
        Upload a single <span class="fw-500 text-dark">Word</span> document, then generate the amendment for signature.
      </p>
    </div>

    @if (canWriteDeals()) {
    <button
      type="button"
      class="btn btn-primary btn-h35 flex-shrink-0 text-nowrap"
      [disabled]="!canGenerate()"
      (click)="generateAmendmentDocument()"
      [appBtnLoader]="generateDocumentButtonId"
    >
      <i class="bi bi-file-earmark-check lh-1"></i>
      Generate
    </button>
    }
  </div>

  @if (!hasUploadedDocument()) { @if (canWriteDeals()) {
  <button
    type="button"
    class="align-items-center bg-light border d-flex document-dropzone flex-column gap-1 justify-content-center px-3 py-4 rounded-3 text-center w-100"
    (click)="fileInput.click()"
  >
    <span
      class="align-items-center bg-body-secondary d-flex justify-content-center mb-1 rounded-circle text-dark wh-40"
    >
      <i class="bi bi-cloud-arrow-up"></i>
    </span>
    <span class="fw-500 text-dark">Click to upload a document</span>
    <span class="fs-12 text-muted">Word files only &middot; .doc or .docx &middot; one file</span>
  </button>
  } @else {
  <div class="bg-light border document-dashed fs-14 px-3 py-4 rounded-3 text-center text-muted">
    No document has been uploaded yet.
  </div>
  } } @else {
  <!-- The uploaded file is content, so it gets its own card. Its actions sit on the card. -->
  <div class="align-items-center bg-white border d-flex gap-3 p-3 rounded-3">
    <span
      class="align-items-center bg-body-secondary d-flex flex-shrink-0 justify-content-center rounded-3 text-dark wh-40"
    >
      <i class="bi bi-file-earmark-word"></i>
    </span>

    <span class="flex-fill overflow-hidden">
      <span class="d-block fw-500 text-dark text-truncate" [title]="uploadedDocument()!.documentName">
        {{ uploadedDocument()!.documentName }}
      </span>
      <span class="d-block fs-12 text-muted">Ready to generate</span>
    </span>

    <span class="align-items-center d-flex flex-shrink-0 gap-1">
      <button
        type="button"
        class="align-items-center border-0 d-inline-flex document-icon-btn justify-content-center p-0 rounded-3 wh-32"
        title="View document"
        aria-label="View document"
        (click)="openUploadedDocumentPreview()"
      >
        <i class="bi bi-eye"></i>
      </button>
      @if (canWriteDeals()) {
      <button
        type="button"
        class="align-items-center border-0 d-inline-flex document-icon-btn justify-content-center p-0 rounded-3 wh-32"
        title="Replace document"
        aria-label="Replace document"
        appBtnLoader="replace-document"
        (click)="fileInput.click()"
      >
        <i class="bi bi-arrow-repeat"></i>
      </button>
      <button
        type="button"
        class="align-items-center border-0 d-inline-flex document-icon-btn document-icon-btn--danger justify-content-center p-0 rounded-3 wh-32"
        title="Remove document"
        aria-label="Remove document"
        (click)="removeUploadedDocument()"
      >
        <i class="bi bi-trash"></i>
      </button>
      }
    </span>
  </div>
  }
</div>

<input #fileInput type="file" class="d-none" accept=".doc,.docx" (change)="onFileChange($event)" />

<ng-template #documentPreviewModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">{{ selectedDocument()?.name }}</h2>
      <span (click)="modal.dismiss('Cross click')" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body overflow-y-auto">
      @if (selectedDocument()?.url) {
      <lib-doc-preview [article]="selectedDocument()!.url"></lib-doc-preview>
      } @else {
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.dismiss('Close')">Close</button>
    </div>
  </div>
</ng-template>
